/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateTagRequestViewModel } from "../types/CreateTagRequestViewModel.ts";
import { eTagStatusSchema } from "./eTagStatusSchema.ts";

export const createTagRequestViewModelSchema = z.object({
  description: z.string().nullish(),
  cultureInfo: z.string().nullish(),
  status: z.optional(
    z.lazy(() => eTagStatusSchema).describe("1 = Active | 2 = Cancelled | "),
  ),
  active: z.optional(z.boolean()),
  forPerson: z.optional(z.boolean()),
  forProspect: z.optional(z.boolean()),
  forInterest: z.optional(z.boolean()),
  isEnrollmentForm: z.optional(z.boolean()),
  observation: z.string().nullish(),
  companyId: z.number().int().nullish(),
}) as unknown as ToZod<CreateTagRequestViewModel>;
